import { useBlocker } from '@tanstack/react-router'
import type React from 'react'
import { useTranslation } from 'react-i18next'

import { AppButton } from './AppButton'
import { Modal } from './Modal'

type UnsavedChangesBlockerProps = {
  isDirty: boolean
  message?: string
}

export const UnsavedChangesBlocker: React.FC<UnsavedChangesBlockerProps> = ({
  isDirty,
  message,
}) => {
  const { t } = useTranslation()
  const blocker = useBlocker({
    enableBeforeUnload: isDirty,
    shouldBlockFn: () => isDirty,
    withResolver: true,
  })

  if (blocker.status !== 'blocked') return null

  return (
    <Modal isOpen onClose={blocker.reset} title={t('common.unsavedChanges.title')} size="sm">
      <div className="space-y-6">
        <p className="text-sm text-gray-700">{message ?? t('common.unsavedChanges.message')}</p>
        <div className="flex justify-end gap-3">
          <AppButton variant="secondary" size="sm" onClick={blocker.reset}>
            {t('common.unsavedChanges.stay')}
          </AppButton>
          <AppButton variant="primary" size="sm" onClick={blocker.proceed}>
            {t('common.unsavedChanges.leave')}
          </AppButton>
        </div>
      </div>
    </Modal>
  )
}
